const axios = require("axios");

export const getSDKVersions = () =>
    axios({
        method: "get",
        url: `https://dashboard.notifica.re/api/v2/info/version`
    });